import { useState } from "react";
import Turnstile from "react-turnstile";
import { useForm } from "react-hook-form";
import axios from "axios";

const compaintTypes = [
    {
        text: "Cohecho",
        value: "Cohecho",
    },
    {
        text: "Lavado de Activos",
        value: "Lavado de Activos",
    },
    {
        text: "Receptación",
        value: "Receptación",
    },
    {
        text: "Financiamiento al Terrorismo",
        value: "Financiamiento al Terrorismo",
    },
    {
        text: "Soborno",
        value: "Soborno",
    },
    {
        text: "Negociación Incompatible",
        value: "Negociación Incompatible",
    },
    {
        text: "Apropiación Indebida",
        value: "Apropiación Indebida",
    },
    {
        text: "Administración desleal",
        value: "Administración desleal",
    },
    {
        text: "Contaminación de aguas",
        value: "Contaminación de aguas",
    },
    {
        text: "Incumplimiento de normas sanitarias",
        value: "Incumplimiento de normas sanitarias",
    },
    {
        text: "Control de Armas",
        value: "Control de Armas",
    },
    {
        text: "Ley de Migraciones (Trata de personas)",
        value: "Ley de Migraciones (Trata de personas)",
    },
    {
        text: "Delitos Informáticos",
        value: "Delitos Informáticos",
    },
];

export const Form = ({ setLoading, setFormSubmitted }) => {
    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm({ mode: "onChange" });

    const [ turnstileToken, setTurnstileToken ] = useState(false);
    const sitekey = document.getElementById("recaptcha_sitekey").getAttribute('value');

    const onSubmit = (data) => {
        sendData(data);
    };

    const sendData = async (data) => {
        setLoading(true);
        const dataToSend = {
            full_name: data.fullname,
            id_number: data.id_number.replaceAll(".", "").replace("-", ""),
            phone_number: data.phone,
            email: data.email,
            complaint_date: data.complaintDate,
            incident_date: data.incidentDate,
            people_involved_outside_TCL: data.peopleInvolvedOutsideTCL,
            people_involved_inside_TCL: data.peopleInvolvedInsideTCL,
            complaint_type: data.complaintType,
            description: data.complaintDescription
        };

        try {
            const resp = await axios.post("/api/website/forms/complaint/", dataToSend, {
                headers: {
                    "X-CSRFToken": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            });
            setLoading(false);
            setFormSubmitted(true)
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    const handleTokenSubmit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            },
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success){
                setTurnstileToken(true);
            }
        })
        .catch((error) => {
            console.log("ERROR", error);
        });
    }

    return (
        <form
            id='complaint-form'
            className='footer-container'
            onSubmit={handleSubmit(onSubmit)}>
            <div className='row-wrapper'>
                <div className='left-section'>
                    <h2 className='subtitle'>Identificación Denunciante</h2>
                    {/* Nombre */}
                    <div className='form-element'>
                        <input
                            type='text'
                            name='fullname'
                            {...register("fullname", {
                                required: "Este campo es requerido",
                                minLength: {
                                    value: 3,
                                    message:
                                        "No se permiten menos de 3 caracteres.",
                                },
                            })}
                        />
                        <label htmlFor='flotas-form' className='label'>
                            Nombre y Apellido
                        </label>
                        {errors.fullname && (
                            <label
                                id='fullname-error'
                                className='error'
                                htmlFor='fullname'>
                                {errors.fullname?.message}
                            </label>
                        )}
                    </div>

                    {/* RUT o pasaporte */}
                    <div className='form-element'>
                        <input
                            type='text'
                            name='id_number'
                            {...register("id_number", {
                                required: "Este campo es requerido",
                            })}
                        />
                        <label htmlFor='flotas-form' className='label'>
                            Cédula Identidad (denunciante): RUT o Pasaporte
                            (Confidencial)
                        </label>
                        {errors.id_number && (
                            <label
                                id='id_number-error'
                                className='error'
                                htmlFor='id_number'>
                                {errors.id_number?.message}
                            </label>
                        )}
                    </div>

                    {/* Teléfono */}
                    <div className='form-element'>
                        <input
                            type='phone'
                            name='phone'
                            {...register("phone", {
                                required: "Este campo es requerido",
                                minLength: {
                                    value: 8,
                                    message: "Ingresa un teléfono válido",
                                },
                                maxLength: {
                                    value: 12,
                                    message: "Ingresa un teléfono válido",
                                },
                            })}
                        />
                        <label htmlFor='phone' className='label'>
                            Teléfono de Contacto
                        </label>
                        {errors.phone && (
                            <label
                                id='phone-error'
                                className='error'
                                htmlFor='phone'>
                                {errors.phone?.message}
                            </label>
                        )}
                    </div>

                    {/* Email */}
                    <div className='form-element'>
                        <input
                            type='email'
                            name='email'
                            {...register("email", {
                                required: "Este campo es requerido",
                                pattern: {
                                    value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                    message: "Ingresa un email valido.",
                                },
                            })}
                        />
                        <label htmlFor='flotas-form' className='label'>
                            Correo Electrónico
                        </label>
                        {errors.email && (
                            <label
                                id='email-error'
                                className='error'
                                htmlFor='email'>
                                {errors.email?.message}
                            </label>
                        )}
                    </div>
                </div>

                <div className='right-section'>
                    <h2 className='subtitle'>Antecedentes de la Denuncia</h2>
                    {/* Fechas */}
                    <div className='form-element-wrapper'>
                        <div className='form-element'>
                            <input
                                type='date'
                                name='complaintDate'
                                {...register("complaintDate", {
                                    required: "Este campo es requerido",
                                })}
                            />
                            <label htmlFor='flotas-form' className='label'>
                                Fecha de la Denuncia
                            </label>
                            {errors.complaintDate && (
                                <label
                                    id='complaintDate-error'
                                    className='error'
                                    htmlFor='complaintDate'>
                                    {errors.complaintDate.message}
                                </label>
                            )}
                        </div>
                        <div className='form-element'>
                            <input
                                type='date'
                                name='incidentDate'
                                {...register("incidentDate", {
                                    required: "Este campo es requerido",
                                })}
                            />
                            <label htmlFor='flotas-form' className='label'>
                                Fecha aprox. del incidente/infracción
                            </label>
                            {errors.incidentDate && (
                                <label
                                    id='incidentDate-error'
                                    className='error'
                                    htmlFor='incidentDate'>
                                    {errors.incidentDate.message}
                                </label>
                            )}
                        </div>
                    </div>

                    {/* Personas involucradas fuera de toyota */}
                    <div className='form-element'>
                        <input
                            type='number'
                            name='peopleInvolvedOutsideTCL'
                            {...register("peopleInvolvedOutsideTCL", {
                                required: "Este campo es requerido",
                            })}
                        />
                        <label htmlFor='flotas-form' className='label'>
                            Número de Personas Involucradas (Externas a TCL)
                        </label>
                        {errors.peopleInvolvedOutsideTCL && (
                            <label
                                id='peopleInvolvedOutsideTCL-error'
                                className='error'
                                htmlFor='peopleInvolvedOutsideTCL'>
                                {errors.peopleInvolvedOutsideTCL?.message}
                            </label>
                        )}
                    </div>

                    {/* Personas involucradas de toyota */}
                    <div className='form-element'>
                        <input
                            type='number'
                            name='peopleInvolvedInsideTCL'
                            {...register("peopleInvolvedInsideTCL", {
                                required: "Este campo es requerido",
                            })}
                        />
                        <label
                            htmlFor='peopleInvolvedInsideTCL'
                            className='label'>
                            Número de Personas Involucradas (Internas a TCL)
                        </label>
                        {errors.peopleInvolvedInsideTCL && (
                            <label
                                id='peopleInvolvedInsideTCL-error'
                                className='error'
                                htmlFor='peopleInvolvedInsideTCL'>
                                {errors.peopleInvolvedInsideTCL?.message}
                            </label>
                        )}
                    </div>

                    {/* Tipo de delito */}
                    <div className='form-element'>
                        <select
                            name='complaintType'
                            {...register("complaintType", {
                                required: "Este campo es requerido",
                            })}
                            defaultValue=''>
                            <option value='' disabled></option>
                            {compaintTypes.map((t) => {
                                return (
                                    <option key={t.value} value={t.value}>
                                        {t.text}
                                    </option>
                                );
                            })}
                        </select>
                        <label htmlFor='flotas-form' className='label'>
                            Tipo de Delito asociado a la Denuncia
                        </label>
                        {errors.complaintType && (
                            <label
                                id='complaintType-error'
                                className='error'
                                htmlFor='complaintType'>
                                {errors.complaintType?.message}
                            </label>
                        )}
                    </div>
                </div>
            </div>

            <div className='row-wrapper'>
                <div className='left-section'>
                    <h2 className='subtitle'>Descripción de la Denuncia</h2>

                    <div className='form-element'>
                        <textarea
                            name='complaintDescription'
                            placeholder='Describa todos los detalles de su denuncia que puedan contribuir a la evaluación y resolución final de este incidente o infracción.'
                            {...register("complaintDescription", {
                                required: "Este campo es requerido",
                            })}
                        />
                        <label htmlFor='flotas-form' className='label'>
                            Descripción de la Denuncia
                        </label>
                        {errors.complaintDescription && (
                            <label
                                id='complaintDescription-error'
                                className='error'
                                htmlFor='complaintDescription'>
                                {errors.complaintDescription?.message}
                            </label>
                        )}
                    </div>
                </div>
            </div>

            <div className='row-wrapper'>
                <div className='left-section'>
                    <p style={{ fontSize: "14px", color: '#D8D8D8' }}>
                        Contamos con un plazo máximo de investigación, el cual
                        es de 45 días hábiles, dentro de este plazo el Encargado
                        de Prevención del Delito se dirigirá a usted, para
                        entregar la respuesta y las medidas implementadas.
                    </p>
                </div>
                <div className='right-section'>
                    <div className='submit-button'>
                        <small className='disclaimer privacy'>
                            <label className='custom-checkbox'>
                                <input
                                    type='checkbox'
                                    name='terms'
                                    onChange={() => setIsChecked(!isChecked)}
                                    {...register("terms", {
                                        required:
                                            "Debes aceptar la política de privacidad.",
                                    })}
                                />
                                <span className='checkmark'></span>
                                <label htmlFor='contact-form'></label>
                                {errors.terms && (
                                    <label
                                        id='terms-error'
                                        className='error'
                                        htmlFor='terms'>
                                        {errors.terms?.message}
                                    </label>
                                )}
                            </label>
                            <span className='terms-text'>
                                Acepto términos y condiciones del canal de
                                denuncias.
                            </span>
                        </small>
                        <span className='feedback-message'></span>
                        <Turnstile
                                theme="dark"
                                sitekey={sitekey}
                                onVerify={(token) => {
                                    handleTokenSubmit(token);
                                }}
                            />
                        <button
                            className='btn white'
                            type='submit'
                            id='button-submit'
                            disabled={!turnstileToken}>
                            Enviar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};
